import { createSlice, PayloadAction } from "@reduxjs/toolkit"

import { RootState } from "app/store"
import { MigrationRequestItem } from "services/pmc-account-switch-apis"

export interface PmcToRboAccountSliceInitialState {
  requestToApproveData: MigrationRequestItem[]
}

const initialState: PmcToRboAccountSliceInitialState = {
  requestToApproveData: [],
}

export const pmcToRboAccountSlice = createSlice({
  name: "pmcToRboAccountSlice",
  initialState,
  reducers: {
    setRequestToApproveData: (
      state,
      action: PayloadAction<MigrationRequestItem[]>,
    ) => {
      state.requestToApproveData = action.payload
    },
  },
})

export const { setRequestToApproveData } = pmcToRboAccountSlice.actions

export const selectRequestToApproveData = (state: RootState) =>
  state.pmcToRboAccountReducer.requestToApproveData

export default pmcToRboAccountSlice.reducer
